import { createContext } from "react";

const ConnectContext = createContext();

export default ConnectContext;